import React from "react";
import { Typography } from "@anchor/react-components/dist/lib/components";

const ChangeTracingLoader = () => {
  return (
    <div 
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa",
        gap: "20px"
      }}
    >
      {/* Loading spinner */}
      <div
        style={{
          width: "60px",
          height: "60px",
          border: "4px solid #e9ecef",
          borderTop: "4px solid #42B0D5",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }}
      />
      
      {/* Loading text */}
      <Typography
        variant="h5"
        style={{
          color: "rgb(0,36,61)",
          fontWeight: "600",
          textAlign: "center"
        }}
      >
        Loading Change Analytics
      </Typography>
      
      <Typography
        variant="body1"
        style={{
          color: "#6c757d",
          textAlign: "center",
          maxWidth: "400px"
        }}
      >
        Preparing audit trail visualization and metrics analysis...
      </Typography>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default ChangeTracingLoader;